import React from 'react';
import PropTypes from 'prop-types';
import { StyledAnimatedLoader, Dots, Dot, Message } from './styles.js';

/* 
 Props:
  -> bgColor: Pass in an rgba value as a string, include desired opacity
    i.e 'rgba(255, 0, 0, 0.3)'
    Default is set in styles.
  -> width: Adjust the width of the dots container to control spacing
*/

export const AnimatedLoader = ({
  bgColor = null,
  message,
  show = false,
  width = null,
  className,
}) => {
  return (
    <StyledAnimatedLoader $bgColor={bgColor} show={show} className={className}>
      <Dots width={width}>
        <Dot />
        <Dot />
        <Dot />
      </Dots>
      {message && <Message>{message}</Message>}
    </StyledAnimatedLoader>
  );
};

AnimatedLoader.displayName = 'AnimatedLoader';

AnimatedLoader.propTypes = {
  bgColor: PropTypes.string,
  message: PropTypes.string,
  show: PropTypes.bool,
  width: PropTypes.string,
  className: PropTypes.string,
};
